import { autoinject } from 'aurelia-framework';
import { ToastOptions } from 'controls/bs-toast-item';
import { DialogHelper } from 'framework/aurelia_dialogs/dialog-helper';
import { ToastMessage, ToastService } from 'framework/aurelia_tools/toast-service';
import { ErrorInfo } from 'framework/error_handling/error-handler';
import { ErrorToast } from 'framework/error_handling/error-toast';

@autoinject
export class ToastHelper {
  constructor(private toastService: ToastService<ToastOptions>, private dialogHelper: DialogHelper) { }

  toast(message: string, heading: string, type: ToastType, format: ToastFormat = ToastFormat.Text) {
    const params = this.types.get(type);
    const toast: ToastMessage<ToastOptions> = {
      model: message,
      view: format,
      instruction: {
        heading: heading,
        class: `--${type}`,
        icon: params.icon,
        delay: params.delay
      }
    };

    this.toastService.show(toast);
  }

  error(info: ErrorInfo, type: ToastType = ToastType.Danger) {
    const params = this.types.get(type);
    const toast: ToastMessage<ToastOptions> = {
      model: info,
      viewModel: new ErrorToast(info, e => this.dialogHelper.error({ message: e.message, dialogTitle: e.title, details: e.details })),
      instruction: {
        heading: info.title,
        class: `--${type}`,
        icon: params.icon,
        delay: params.delay
      }
    };

    this.toastService.show(toast);
  }

  private types = new Map([
    [ToastType.Success, { icon: 'fas fa-check-square', delay: 3500 }],
    [ToastType.Warning, { icon: 'fas fa-exclamation-triangle', delay: 5000 }],
    [ToastType.Danger, { icon: 'fas fa-exclamation-triangle', delay: 7000 }]
  ]);
}

export enum ToastType {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger'
}

export enum ToastFormat {
  Text = 'templates/text-toast.html',
  Html = 'templates/html-toast.html'
}
